import { render, staticRenderFns } from "./FeatureAudiences.vue?vue&type=template&id=b0c79d04"
import script from "./FeatureAudiences.vue?vue&type=script&lang=js"
export * from "./FeatureAudiences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports